import styled from "styled-components";

export const StyledEstimateResults = styled.section`
  width: 100%;

  @media (min-width: 1200px) {
    position: sticky;
    top: calc(var(--navbar-height) + var(--content-gap-top));
    width: 360px;
    flex-shrink: 0;
    margin-right: 1.5rem;
  }

  border: 1px solid
    color-mix(in srgb, var(--brand-purple-500) 20%, var(--brand-white));
  border-radius: 16px;
  overflow: hidden;
  background: var(--brand-white);

  .results-head {
    padding: 1.25rem;
    background: linear-gradient(
      180deg,
      color-mix(in srgb, var(--brand-purple-700) 8%, var(--brand-white)) 0%,
      var(--brand-white) 100%
    );
  }

  .results-eyebrow {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    color: var(--brand-purple-600);
    font-size: 0.8125rem;
    font-weight: var(--font-weight-bold);
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .results-label {
    color: var(--brand-gray-600);
    font-size: 0.875rem;
  }

  .results-placeholder {
    display: inline-block;
    width: 2rem;
    height: 4px;
    border-radius: 2px;
    background: var(--brand-black);
  }

  .results-placeholder.is-small {
    width: 1.5rem;
    height: 3px;
  }

  .results-placeholder.is-row {
    width: 0.875rem;
    height: 2px;
  }

  .results-headline {
    margin: 0;
    font-size: 2.25rem;
    font-weight: var(--font-weight-bold);
    line-height: 1.1;
    color: var(--brand-black);
  }

  .results-skeleton {
    display: inline-block;
    border-radius: 4px;
    background: linear-gradient(
        90deg,
        var(--brand-gray-100) 25%,
        var(--brand-gray-200) 37%,
        var(--brand-gray-100) 63%
      )
      var(--brand-gray-100);
    background-size: 400% 100%;
    animation: results-shimmer 1.4s ease infinite;
  }

  .results-skeleton.is-headline {
    width: 8rem;
    height: 1.75rem;
  }

  .results-skeleton.is-figure {
    width: 5rem;
    height: 1.25rem;
  }

  .results-skeleton.is-row {
    width: 3.5rem;
    height: 0.875rem;
  }

  @keyframes results-shimmer {
    0% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0 50%;
    }
  }

  .results-figures {
    display: grid;
    grid-template-columns: 1fr 1fr;
    border-top: 1px solid var(--brand-gray-200);
  }

  .results-figure {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 1rem 1.25rem;
  }

  .results-figure:only-child {
    grid-column: 1 / -1;
  }

  .results-figure-label {
    font-size: 0.75rem;
  }

  .results-figure-value {
    margin: 0.5rem 0 0;
    font-size: 1.125rem;
    font-weight: var(--font-weight-bold);
    color: var(--brand-black);
  }

  .results-figure + .results-figure {
    border-left: 1px solid var(--brand-gray-200);
  }

  .results-breakdown {
    padding: 1rem 1.25rem;
    border-top: 1px solid var(--brand-gray-200);
  }

  .results-breakdown-toggle {
    width: 100%;
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;

    font-size: 0.9375rem;
    font-weight: var(--font-weight-semibold);
    color: var(--brand-black);
  }

  .results-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    margin-top: 0.875rem;
  }

  .results-row-value {
    font-size: 0.875rem;
    color: var(--brand-black);
  }

  .results-total {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;

    margin-top: 0.875rem;
    padding-top: 0.875rem;
    border-top: 1px solid var(--brand-gray-200);

    font-size: 0.875rem;
    font-weight: var(--font-weight-semibold);
    color: var(--brand-black);
  }
`;
